'use client';

import clsx from 'clsx';
import { useState } from 'react';
import Accordion from '@/components/Accordion/Accordion';
import Button, { ButtonType } from '@/components/Button/Button';
import styles from './FAQ.module.scss';
import Text from '@/components/Text/Text';

interface IButton {
  id: number,
  title: string,
  type: ButtonType,
  link: string
}
export interface IFAQ {
  __component: string;
  id: number;
  title: string,
  description: string,
  button: IButton;
  cards: {
    id: number;
    title: string;
    description: string,
  }[]
}

const FAQ = ({ data, isMembership = false }: { data: IFAQ, isMembership?: boolean }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className={clsx(styles.faq, { [styles.membership]: isMembership })}>
      <div className={styles.contact}>
        <div className={styles.textContent}>
          <Text tag='h2'>{data.title}</Text>
          <p>{data.description}</p>
        </div>
        {data.button && (
          <Button
            type={data.button.type}
            href={data.button.link}
            fitContent
            iconName='arrow_forward'
          >
            {data.button.title}
          </Button>
        )}
      </div>

      <div className={styles.faqContent}>
        {data.cards.map((card, index) => (
          <Accordion
            isFAQ
            key={card.id}
            title={card.title}
            description={card.description}
            toggleAccordion={() => toggleAccordion(index)}
            isOpen={openIndex === index}
            // biggerText={isMembership && index === 0}
          />
        ))}
      </div>
    </section>
  );
};

export default FAQ;
